import React from 'react';

const FormInput = ({ label, type = 'text', register, name, rules, errors, placeholder }) => {
    const error = errors[name];

    return (
        <div className="flex flex-col mb-4">
            <label htmlFor={name} className="mb-1 text-sm font-medium text-gray-700">
                {label} {rules?.required && <span className="text-red-500">*</span>}
            </label>
            <input
                id={name}
                type={type}
                placeholder={placeholder}
                className={`px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300'
                    }`}
                {...register(name, rules)}
            />
            {error && (
                <span className="mt-1 text-xs text-red-500">{error.message}</span>
            )}
        </div>
    );
};

export default FormInput;